import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  active: false,
  msg: null,
  onOk: null,
  onCancel: null
});

export function show(state, msg, onOk, onCancel) {
  return state.merge({ active: true, msg, onOk, onCancel });
}

export function hide(state) {
  return state.merge({ active: false, msg: null, onOk: null, onCancel: null });
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CONFIRMATION_SHOW':
      return show(state, action.msg, action.onOk, action.onCancel);

    case 'CONFIRMATION_HIDE':
      return hide(state);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/confirmation.js